import { createSelector } from 'reselect'
import { INITIAL_STATE } from './reducer'

export const onlinePingStateSelector = state => state.onlinePing || INITIAL_STATE

export const isOnlinePingSelector = createSelector(
  onlinePingStateSelector,
  state => state.isOnlinePing
)
